export default __webpack_public_path__ + "static/media/share_data_with_coalition.29811249.svg";